import React from 'react'
import { Nav, NavDropdown } from 'react-bootstrap'
import styles from '../Header.module.css'
import { Item } from '../Header'
import useHoverDropdown from '../useHoverDropdown'
import { isIndia } from '../../../../constants/currency'
import { PLANS } from '../../../../constants/plans'
import { showUpgradeCardModal } from '../../../../actions'
import { onUpgradePlan } from '../../../../utils/general'
import { openPrioritySupportCalendar } from '../../../../utils/calEmbed'

const HelpDropdown = ({ hasAPIAccess, userProfile, dispatch }) => {
  const hoverProps = useHoverDropdown()
  const isProOrProMax = userProfile?.productId === PLANS.PRO_U.id || userProfile?.productId === PLANS.PRO_MAX.id

  const handlePrioritySupportClick = () => {
    if (isProOrProMax) {
      openPrioritySupportCalendar()
    } else {
      dispatch(
        showUpgradeCardModal({
          title: 'Upgrade for Priority Support',
          desc: 'Book a call with our helpful support team to get your questions answered faster.',
          cta: 'Upgrade to Pro',
          onClick: () => onUpgradePlan({ planId: PLANS.PRO_U.id, userProfile }, dispatch)
        })
      )
    }
  }

  return (
    <Nav.Item className="integration-tab">
      <NavDropdown
        className="p-md-0 m-auto dropdown-toggle"
        title={
          <span className={styles.contentBoxNav}>
            <img src="/assets/icons/help.svg" alt="Help" className={styles.img} />
            <span className={styles.contentText}>Help</span>
          </span>
        }
        variant="link"
        {...hoverProps}
      >
        <div className={styles.menu}>
          <div className={styles.contentContainer}>
            <Item
              icon="help-desk.svg"
              alt="Help Desk"
              label="Help Desk"
              href="https://helpdesk.tiiny.host"
              target="_blank"
            />
            {!isIndia && (
              <Item
                icon="support.svg"
                alt="Support"
                label="Support"
                onClick={() => window.$crisp.push(['do', 'chat:open'])}
              />
            )}
            <Item
              icon="email.svg"
              alt="Email Support"
              label="Email Support"
              href="mailto:support@tiiny.host?subject=Help Request"
            />
            <Item
              icon="headphones-black.svg"
              alt="Priority Support"
              label="Priority Support"
              onClick={handlePrioritySupportClick}
            />
            {hasAPIAccess && (
              <Item icon="cog.svg" alt="API Docs" label="API Docs" href="https://api-docs.tiiny.co" target="_blank" />
            )}
          </div>
        </div>
      </NavDropdown>
    </Nav.Item>
  )
}

export default HelpDropdown
